export default __webpack_public_path__ + "static/media/Helm of Effulgent Devotion.204068dd.jpg";